export default {
  green: '#d5f0d3',
  orange: '#fceccb',
  red: '#ffcdcd',
  blue: '#d3e7f2',
  yellow: '#fff9db',
  orangeDark: '#f2894e'
};